// This icon file is generated automatically.
var PVideoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.25 3.72l-2 1.15V2.5a1 1 0 00-1-1H1a1 1 0 00-1 1v9a1 1 0 001 1h9.25a1 1 0 001-1V9.12l2 1.16a.5.5 0 00.75-.43v-5.7a.5.5 0 00-.75-.43zm-3.13 7.65h-9V2.63h9v8.75zm2.76-2.6l-1.63-.94V6.17l1.63-.94v3.54zM2.24 4.63H4c.07 0 .13-.06.13-.13v-.75A.13.13 0 004 3.62H2.25a.13.13 0 00-.13.13v.75c0 .07.06.13.13.13z", "fill-rule": "nonzero" } }] }, "name": "p-video", "theme": "outlined" };
export default PVideoOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVideoOutlined.js
// module id = 3726
// module chunks = 0